<h2 class="mat-title">
  <ng-content></ng-content>
</h2>
